import React from 'react';
import { useSelector } from 'react-redux'

import { parseUrl, joinUrl } from "./wheel-urls.js";

const DiameterSearchLinks = () => {
  const diameters = useSelector(state => state.cars.selectedCarDiameters);

  var parsedUrl = parseUrl();

  var root = joinUrl({ ...parsedUrl, diameters: null });

  var diameter = (parsedUrl || {}).diameters;

  // se il diametro nell'url non risulta tra quelli presenti nella lista 

  if (!(diameters || []).some(s => s.Key == diameter) && parsedUrl) {
    parsedUrl.diameters = null;

    // lo eliminiamo dall'url

    window.history.pushState("", "", joinUrl(parsedUrl));
  }

  if (diameters) {
    var items = [];

    //const parsed = MapQueryStringToObject(window.location);
    //console.log("!!!parsed", parsed);

    diameters.forEach((v, i, a) => {
      if (!v.Invalid) {
        items.push(
          <li key={"wheel-diameter-" + i} style={(v.Selected || false) ? { backgroundColor: "#f7f7f7", "fontWeight": 700 } : {}}>
            {(v.Key == diameter) &&
            <div>
              <span>
                {v.Name}
              </span>
              <a href={root} title="Rimuovi" alt="Rimuovi">
                <span style={{ fontSize: "13px", height: "10px", width: "10px", color: "#46464A", position: "absolute", right: "10px", fontWeight: 500 }}>
                  {(v.Key == diameter) ? "X" : ""}
                </span>
              </a>
            </div>
            }
            {(v.Key != diameter) &&
            <a href={v.Url} title={v.Title}>
              <div>
                <span>
                  {v.Name}
                </span>
              </div>
            </a>
            }
          </li>
        );
      }
    });

    items.push(
      <li key={"wheel-diameter-empty-1"} style={{ borderTop: "0px solid" }}>&nbsp;</li>
    );
    items.push(
      <li key={"wheel-diameter-empty-2"} style={{ borderTop: "0px solid" }}>&nbsp;</li>
    );
    items.push(
      <li key={"wheel-diameter-empty-3"} style={{ borderTop: "0px solid" }}>&nbsp;</li>
    );

    return (
      items
    );
  }

  return null;
};

export { DiameterSearchLinks };